import { IS_LOCAL_NX_DEV } from "@bridgesplit/utils";
import { useWallet } from "@solana/wallet-adapter-react";

// luke is a good test wallet LoTy38EiLYg85rWq5okYjNwzQECGbYa6uPcJPj8MHu2
// jason -> 67VABVhoSdcWy29XPHs4a9z99ggmWTgenLGxeWYo3o62
// const debugWallet: string | null = "3DiYhBUpb1WSt3dVcHwCQa2irnSX5oG6rPQLqzyn3Ntj";
const debugWallet: string | null = null;
export const DEBUG_WALLET = IS_LOCAL_NX_DEV ? debugWallet : null;
export const useUserPublicKey = (): string | undefined => {
    const wallet = useWallet();
    if (DEBUG_WALLET) return DEBUG_WALLET;
    return wallet ? wallet.publicKey?.toString() : undefined;
};

const SIMULATE_ONLY_KEY = "bs:simulate-only";

/**
 * Generate transactions and simulate them instead of sending, without requiring a connected wallet.
 *
 * Unlike DEBUG_WALLET this does not impersonate a pubkey anywhere else in the app - it only skips
 * the wallet connect ceremony in front of transaction generation. The payer is resolved server side
 * from the signed in email (auth middleware sets the payer header from the user's wallet address),
 * so an email-only session can still produce a real transaction to evaluate.
 *
 * Toggle with ?simulateOnly=1 (persisted) or ?simulateOnly=0 to clear.
 */
export function isSimulateOnly(): boolean {
    if (typeof window === "undefined") return false;
    try {
        const param = new URLSearchParams(window.location.search).get("simulateOnly");
        if (param !== null) {
            const enabled = param !== "0" && param !== "false";
            window.localStorage.setItem(SIMULATE_ONLY_KEY, enabled ? "1" : "0");
            return enabled;
        }
        return window.localStorage.getItem(SIMULATE_ONLY_KEY) === "1";
    } catch {
        // private browsing or blocked storage - treat as off rather than breaking the send path
        return false;
    }
}
